import React from 'react';
import clsx from 'clsx';

import { IProps } from './FiftyFiftyVideoBlock.interface';
import './FiftyFiftyVideoBlock.styles.css';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper from '@/layouts/ContentWrapper/ContentWrapper.component';
import { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import { FeatureVideoWidget } from '@/blocks/FeatureVideoBlock/FeatureVideoBlock.component';
import Button from '@/elements/Button/Button.component';

const FiftyFiftyVideoBlock: React.FC<IProps> = ({
    className,
    heading,
    text,
    buttons,
    video,
    videoDescription,
    transcript,
    transcriptButtonText,
    transcriptButtonTextOpen,
    mediaPosition = 'left',
    ...blockWrapperProps
}) => {

    const videoColOrder = clsx({
        'order-2': true, // Image is always second on mobile
        'md:order-1': mediaPosition === 'left',
        'md:order-2': mediaPosition === 'right',
    });

    const textColOrder = clsx({
        'order-1': true, // Text is always first on mobile
        'md:order-2': mediaPosition === 'left',
        'md:order-1': mediaPosition === 'right',
    });

    return (
        <BlockWrapper
            className={clsx('fiftyFiftyVideoBlock', className, {
                'fiftyFiftyVideoBlock--mediaLeft': mediaPosition === 'left',
                'fiftyFiftyVideoBlock--mediaRight': mediaPosition === 'right',
            })}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                {/* Mobile: Text always first. Desktop: Order based on mediaPosition */}
                <ContentColumn layout="half" className={clsx("fiftyFiftyVideoBlock__textColumn", textColOrder)}>
                    {heading &&
                        <Heading
                            level={2}
                            html={heading}
                            className="fiftyFiftyVideoBlock__heading"
                        />
                    }

                    {text &&
                        <Text
                            html={text}
                            className="fiftyFiftyVideoBlock__text"
                        />
                    }

                    {buttons && buttons.length > 0 && (
                        <div className="fiftyFiftyVideoBlock__buttons">
                            {buttons.map((button, index) => (
                                <Button
                                    key={`fiftyFiftyVideoBlock__button-${index}`}
                                    {...button}
                                    className={'fiftyFiftyVideoBlock__button'}
                                />
                            ))}
                        </div>
                    )}
                </ContentColumn>
                <ContentColumn layout="half" className={clsx("fiftyFiftyVideoBlock__videoColumn", videoColOrder)}>
                    <FeatureVideoWidget
                        video={video}
                        description={videoDescription} // Map prop name
                        transcript={transcript}
                        transcriptButtonText={transcriptButtonText}
                        transcriptButtonTextOpen={transcriptButtonTextOpen}
                    />
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { FiftyFiftyVideoBlock }
